import React from 'react';
import _ from 'lodash';

export const formatFieldValuesForEndpoint = (preformattedValues) => {
  const fieldValues = _.clone(preformattedValues);
  let newValues = _.merge({}, fieldValues);
  newValues.KidsCount = (fieldValues.KidsCount) || 0;
  newValues.IncomeYearly = String(fieldValues.IncomeYearly).replace(/,/g, '');
  delete newValues.OriginalFamilyType;
  delete newValues.ResultsType;
  delete newValues.QuizRoute;

  console.log(newValues);

  if (newValues.Quote === 'Medicare') {
    delete newValues.Age;
    delete newValues.Essential;
    delete newValues.FamilyType;
    delete newValues.IncomeYearly;
    delete newValues.KidsCount;
    delete newValues.Medicaid;
    delete newValues.Medicare;
    delete newValues.TotalFamilySize;
  }

  if (newValues.Quote === 'small-business') {
    delete newValues.Age;
    delete newValues.Essential;
    delete newValues.FamilyType;
    delete newValues.IncomeYearly;
    delete newValues.KidsCount;
    delete newValues.Medicaid;
    delete newValues.Medicare;
    delete newValues.TotalFamilySize;
  } else if (newValues.Quote !== 'small-business') {
    delete newValues.MetalLevel;
    delete newValues.FullTimeEmployees;
  }

  if (newValues.Quote === 'medicaid' ||
    newValues.Quote === 'child-health-plus' ||
    newValues.Quote === 'essential') {
    delete newValues.CostPreference;
    delete newValues.Medicare;
  }

  if (newValues.Quote === 'families') {
    delete newValues.Age;
    delete newValues.CostPreference;
    delete newValues.Medicare;
  }

  if ((newValues.Quote === 'medicaid' && newValues.FamilyType !== 'Individual') ||
    newValues.Quote === 'child-health-plus' ||
    newValues.Quote === 'essential') {
    delete newValues.Age;
  }

  return newValues;
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getPremiumsForResult = ({
  deductible,
  famType,
  max,
  premium,
  result,
  Subsidy
}) => {
  const premiums = {
    annualDeductible: '',
    highestDeductible: '',
    highestMax: '',
    highestPremium: '',
    lowestDeductible: '',
    lowestMax: '',
    lowestPremium: '',
    monthlyPremium: '',
    oopmax: '',
    welcome: ''
  };

  // all arguments are required for this method:
  if (_.isUndefined(premium) || !premium) return false;
  if (_.isUndefined(result) || !result) return false;
  if (_.isUndefined(deductible) || !deductible) return false;
  if (_.isUndefined(famType) || !famType) return false;
  if (_.isUndefined(max) || !max) return false;

  switch (famType) {
    case 'Individual' :
      premiums.monthlyPremium = result.MonthlyIndividualPremium;
      premiums.annualDeductible = result.IndividualDeductible;
      premiums.oopmax = result.IndividualOopMax;
      premiums.welcome = 'you.';
      premiums.lowestPremium = premium[0].MonthlyIndividualPremium;
      premiums.highestPremium = premium[premium.length - 1].MonthlyIndividualPremium;
      premiums.lowestDeductible = deductible[0].IndividualDeductible;
      premiums.highestDeductible = deductible[deductible.length - 1].IndividualDeductible;
      premiums.lowestMax = max[0].IndividualOopMax;
      premiums.highestMax = max[max.length - 1].IndividualOopMax;
      break;

    case 'Couple' :
      premiums.monthlyPremium = result.MonthlyCouplePremiumSelfSpouse;
      premiums.annualDeductible = result.FamilyDeductible;
      premiums.oopmax = result.FamilyOopMax;
      premiums.welcome = 'you and your spouse.';
      premiums.lowestPremium = premium[0].MonthlyCouplePremiumSelfSpouse;
      premiums.highestPremium = premium[premium.length - 1].MonthlyCouplePremiumSelfSpouse;
      premiums.lowestDeductible = deductible[0].FamilyDeductible;
      premiums.highestDeductible = deductible[deductible.length - 1].FamilyDeductible;
      premiums.lowestMax = max[0].FamilyOopMax;
      premiums.highestMax = max[max.length - 1].FamilyOopMax;
      break;

    case 'CoupleChildren' :
      premiums.monthlyPremium = result.MonthlyFamilyPremium;
      premiums.annualDeductible = result.FamilyDeductible;
      premiums.oopmax = result.FamilyOopMax;
      premiums.welcome = 'you and your\u00a0family.';
      premiums.lowestPremium = premium[0].MonthlyFamilyPremium;
      premiums.highestPremium = premium[premium.length - 1].MonthlyFamilyPremium;
      premiums.lowestDeductible = deductible[0].FamilyDeductible;
      premiums.highestDeductible = deductible[deductible.length - 1].FamilyDeductible;
      premiums.lowestMax = max[0].FamilyOopMax;
      premiums.highestMax = max[max.length - 1].FamilyOopMax;
      break;

    case 'IndividualChildren' :
      premiums.monthlyPremium = result.MonthlySingleParentKidsPremium;
      premiums.annualDeductible = result.FamilyDeductible;
      premiums.oopmax = result.FamilyOopMax;
      premiums.welcome = 'you and your kids.';
      premiums.lowestPremium = premium[0].MonthlySingleParentKidsPremium;
      premiums.highestPremium = premium[premium.length - 1].MonthlySingleParentKidsPremium;
      premiums.lowestDeductible = deductible[0].FamilyDeductible;
      premiums.highestDeductible = deductible[deductible.length - 1].FamilyDeductible;
      premiums.lowestMax = max[0].FamilyOopMax;
      premiums.highestMax = max[max.length - 1].FamilyOopMax;
      break;

    case 'ChildrenOnly' :
      premiums.monthlyPremium = result.MonthlySingleParentKidsPremium;
      premiums.annualDeductible = result.FamilyDeductible;
      premiums.oopmax = result.FamilyOopMax;
      premiums.welcome = 'your kids.';
      premiums.lowestPremium = premium[0].MonthlySingleParentKidsPremium;
      premiums.highestPremium = premium[premium.length - 1].MonthlySingleParentKidsPremium;
      premiums.lowestDeductible = deductible[0].FamilyDeductible;
      premiums.highestDeductible = deductible[deductible.length - 1].FamilyDeductible;
      premiums.lowestMax = max[0].FamilyOopMax;
      premiums.highestMax = max[max.length - 1].FamilyOopMax;
      break;

    default:
      break;
  }

  if (Subsidy > 0) {
    premiums.monthlyPremium = premiums.monthlyPremium - Subsidy.toFixed(2);
    premiums.lowestPremiumNum = premiums.lowestPremium - Subsidy;
    premiums.highestPremiumNum = premiums.highestPremium - Subsidy;
    premiums.lowestPremium = numberWithCommas(Math.round(premiums.lowestPremiumNum));
    premiums.highestPremium = numberWithCommas(Math.round(premiums.highestPremiumNum));
  } else {
    premiums.lowestPremium = premiums.lowestPremium ? numberWithCommas(Math.round(premiums.lowestPremium)) : '';
    premiums.highestPremium = premiums.highestPremium ? numberWithCommas(Math.round(premiums.highestPremium)) : '';
  }

  premiums.lowestDeductible = premiums.lowestDeductible ? numberWithCommas(premiums.lowestDeductible) : '0';
  premiums.highestDeductible = premiums.highestDeductible ? numberWithCommas(premiums.highestDeductible) : '';
  premiums.lowestMax = premiums.lowestMax ? numberWithCommas(premiums.lowestMax) : '0';
  premiums.highestMax = premiums.highestMax ? numberWithCommas(premiums.highestMax) : '';

  return premiums;
};

export const getCHPTotals = ({
  rest,
  quiz,
  premiums,
  Subsidy,
  result,
  showCHP
}) => {
  const chpVars = {
    calculateCHP: '',
    childLang: '',
    childLang02: '',
    chpMax: '',
    chpNotice: '',
    chpTotal: '',
    enrollCHP: '',
    essentialNotice: '',
    monthlyCHP: '',
    newMonthlyRate: '',
    newMonthlyRateNum: '',
    numberOfKids: '',
    originalFamilyType: '',
    welcomeEssential: ''
  };

  if (chpVars.chpTotal < chpVars.chpMax) {
    chpVars.monthlyCHP = chpVars.chpTotal;
  } else {
    chpVars.monthlyCHP = chpVars.chpMax;
  }

  if (showCHP) {
    if (chpVars.originalFamilyType === 'IndividualChildren') {
      premiums.welcome = 'you';
    }
    if (chpVars.numberOfKids === '1') {
      chpVars.childLang = 'child is';
      chpVars.childLang02 = 'child';
    } else {
      chpVars.childLang = 'children are';
      chpVars.childLang02 = 'children';
    }
    chpVars.chpNotice = <strong>Your {chpVars.numberOfKids} {chpVars.childLang} eligible for Child Health Plus:</strong>;
    chpVars.calculateCHP = (<span> ${chpVars.monthlyCHP}/month with no additional costs.<br />
      Call <a
        href='tel:866-692-3747'
        className='tel'>866-692-3747</a> or
      <a onClick={() => this.scrollTo()}>complete the form</a>to learn more or enroll any time.</span>);
    chpVars.enrollCHP = <span className='copy'>You can enroll your {chpVars.childLang02} in <strong>Child Health Plus</strong> at any time.</span>;
  }

  return chpVars;
};

export const essentialPlanCallout = ({
  rest,
  quiz,
  premiums,
  Subsidy,
  result
}) => {
  const epcVars = {
    essentialNotice: '',
    newMonthlyRate: '',
    newMonthlyRateNum: '',
    showEssential: ''
  };

  const showEssential = (quiz.fieldValues.KidsCount === '0' &&
        (epcVars.originalFamilyType === 'IndividualChildren' ||
        epcVars.originalFamilyType === 'CoupleChildren'));

  if (premiums.planOrderPremium) {
    if (showEssential) {
      if (epcVars.originalFamilyType === 'IndividualChildren') {
        epcVars.welcomeEssential = 'you';
        epcVars.newMonthlyRateNum = result.MonthlyIndividualPremium - Subsidy;
        epcVars.newMonthlyRate = numberWithCommas(epcVars.newMonthlyRateNum.toFixed(2));
      } else {
        epcVars.welcomeEssential = 'you and your spouse';
        epcVars.newMonthlyRateNum = result.MonthlyCouplePremiumSelfSpouse - Subsidy;
        epcVars.newMonthlyRate = numberWithCommas(epcVars.newMonthlyRateNum.toFixed(2));
      }
      console.log('SHOW ESSENTIAL :: ' + Subsidy);
      epcVars.essentialNotice = (<span><strong>Potential Cost Saving Tip:</strong> Children over age 19 may be eligible for a free or low cost <a href='/essential'>Essential plan</a>, reducing the monthly fee to as low as <strong>${epcVars.newMonthlyRate}</strong> on a plan for just {epcVars.welcomeEssential}. Call <a href='tel:866-692-3747' className='tel'>866-692-3747</a> for help deciding.</span>);
    }
  }
  return epcVars;
};

export const _defaultResultsState = {
  'animateChangePrice': false,
  'data': {},
  'FamilyType': '', // this.props.quiz.fieldValues.FamilyType,
  'FamilyTypePlural': 'Individuals',
  'formResults': {}, // this.props.quiz.fieldValues,
  'headerHeight': 100,
  'includeChildHealthPlus': false,
  'loading': true,
  'mobileChangeColumn': '',
  'mounted': false,
  'open': false,
  'plans': [],
  'plansInRegion': [],
  'selectedPlan': [],
  'selectedPlanID': '',
  'showModal': false,
  'url': `${process.env.REACT_APP_API_URL}/plans/individual`
};

export const sendAnalyticsOnQuote = (fieldValues, rest) => {
  console.log('FIRE ANALYTICS');
  let planType, planLevel, deductibleType, visitorType, eventLabel;
  let label = fieldValues.FamilyType.charAt(0).toUpperCase() + fieldValues.FamilyType.slice(1);

  switch (fieldValues.Quote) {
    case 'individuals':
      planType = rest.quote.selectedPlan.PlanType;
      planLevel = rest.quote.MetalLevel;
      deductibleType = rest.quote.deductibleType;
      visitorType = 'Prospect - Individual Non-Medicare';
      eventLabel = label + ' Quote';
      break;

    case 'families':
      planType = rest.quote.selectedPlan.PlanType;
      planLevel = rest.quote.MetalLevel;
      deductibleType = rest.quote.deductibleType;
      visitorType = 'Prospect - Family';
      eventLabel = label + ' Quote';
      break;

    case 'child-health-plus':
      planType = 'HDHMO';
      planLevel = 'Bronze';
      deductibleType = 'Yes';
      visitorType = 'Prospect - CHP';
      eventLabel = 'CHP Quote';
      break;

    case 'small-business':
      planType = rest.quote.selectedPlan.PlanType;
      planLevel = rest.quote.MetalLevel;
      deductibleType = rest.quote.deductibleType;
      visitorType = 'Prospect - Small Group';
      eventLabel = 'Group Quote';
      break;

    case 'medicaid':
      planType = 'HDHMO';
      planLevel = 'Bronze';
      deductibleType = 'Yes';
      visitorType = 'Prospect - Medicaid';
      eventLabel = (fieldValues.KidsCount > 0 ? 'Medicaid+CHP Quote' : 'Medicaid Quote');
      break;

    case 'essential':
      planType = 'Essential';
      planLevel = 'Bronze';
      deductibleType = rest.quote.deductibleType;
      visitorType = 'Prospect - Essential';
      eventLabel = (fieldValues.KidsCount > 0 ? 'Essential+CHP Quote' : 'Essential Quote');
      break;

    case 'medicare':
      planType = rest.quote.selectedPlan.PlanType;
      planLevel = rest.quote.MetalLevel;
      deductibleType = rest.quote.deductibleType;
      visitorType = 'Prospect - Medicare';
      eventLabel = 'Medicare Quote';
      break;
  }

  _recordQuoteAnalytics({
    visitorType,
    eventLabel,
    planLevel,
    planType,
    deductibleType
  });
  _updateCallRails();
};

const _recordQuoteAnalytics = (options) => {
  for (let k in options) if (_.isUndefined(options[k])) delete options[k];
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(_.merge, {}, options, {
    'event': 'GAEvent',
    'eventCategory': 'View',
    'eventAction': 'Results'
  });
};

const _updateCallRails = () => {
  console.log('callTrkFire');
  let newScript = document.createElement('script');
  let inlineScript = document.createTextNode('setTimeout(function(){ CallTrk.swap(); document.body.classList.add("loaded");}, 500);');
  newScript.setAttribute('id', 'calltrk');
  newScript.appendChild(inlineScript);
  document.getElementsByTagName('body')[0].appendChild(newScript);
};